import { render, staticRenderFns } from "./menuSetting.vue?vue&type=template&id=5361d6c2&scoped=true"
import script from "./menuSetting.vue?vue&type=script&lang=js"
export * from "./menuSetting.vue?vue&type=script&lang=js"
import style0 from "./menuSetting.vue?vue&type=style&index=0&id=5361d6c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5361d6c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5361d6c2')) {
      api.createRecord('5361d6c2', component.options)
    } else {
      api.reload('5361d6c2', component.options)
    }
    module.hot.accept("./menuSetting.vue?vue&type=template&id=5361d6c2&scoped=true", function () {
      api.rerender('5361d6c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/menuSetting.vue"
export default component.exports